import { OrganizationSchemaScript } from './variants/OrganizationSchemaScript';
import { ProductSchemaScript } from './variants/ProductSchemaScript';
import type { SchemaOrgProps } from './types';
import { ArticleSchemaScript, AiDisclosureImageSchemaScript } from './variants';

/**
 * SchemaOrg Component
 *
 * Renders Schema.org JSON-LD scripts from pre-transformed schema objects.
 *
 * This component is purely presentational - all transformation logic
 * happens in SchemaOrgTransformer (data-layer).
 *
 * @param organizationSchema - Pre-transformed Organization schema (for StartPage)
 * @param productSchema - Pre-transformed Product schema (for ShopgroupPage)
 * @param articleSchema - Pre-transformed Article schema (for MasterPage editorial content)
 */
export function SchemaOrg(props: SchemaOrgProps) {
  const { organizationSchema, productSchema, articleSchema, aiDisclosureImageSchemas } = props;

  return (
    <>
      {organizationSchema && <OrganizationSchemaScript schema={organizationSchema} />}
      {productSchema && <ProductSchemaScript schema={productSchema} />}
      {articleSchema && <ArticleSchemaScript schema={articleSchema} />}
      {!!aiDisclosureImageSchemas?.length && <AiDisclosureImageSchemaScript schemas={aiDisclosureImageSchemas} />}
    </>
  );
}
